const cache = new Map();

/** Dynamic import for Lottie JSON — each file becomes its own async chunk. */
export function fetchLottieData(importFn, cacheKey) {
  const key = cacheKey || importFn.toString();
  if (!cache.has(key)) {
    cache.set(
      key,
      importFn().then((mod) => mod.default ?? mod)
    );
  }
  return cache.get(key);
}
